module.exports = __webpack_public_path__ + "img/20210422.3a8cf798.png";